import Button from '@/components/Button';
import { useNavigate } from 'react-router-dom';

export default function NotAuthorizedPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[44rem] items-center justify-center">
      <div className="flex flex-col items-center gap-8">
        <div className=" flex flex-col items-center gap-4">
          <h1 className=" text-sh-md font-bold">Not authorized</h1>
          <p className=" text-sh-sm"> Not authorized </p>
        </div>
        <Button theme="solid" onClick={() => navigate('/')}>
          Back to Home
        </Button>
      </div>
    </div>
  );
}
